import { useContext } from 'react';
import { ChatContext, ChatQueryContext } from './ChatContext';

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};

/** Subscribes to the prompt; re-renders on each keystroke. Use only where the text is shown or edited. */
export const useChatQuery = () => {
  const context = useContext(ChatQueryContext);
  if (!context) {
    throw new Error('useChatQuery must be used within a ChatProvider');
  }
  return context;
};
